"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Level = exports.LevelGroupTitle = exports.Bar = exports.BarGroup = exports.BarButton = exports.LevelGroup = exports.StyledH3 = exports.TitleBg = exports.ChartHelper = exports.ChartItems = exports.ChartWrap = exports.Chart = exports.Content = exports.ContentWrap = exports.Wrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "c8dls-0"
})(["background:", ";border-radius:", ";box-shadow:", ";padding:", ";display:flex;flex-direction:column;@media (min-width:", "){padding:", ";flex-direction:row;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.card.backgroundColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.card.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.card.boxShadow;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.md;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.md;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.xxxl;
});
exports.Wrapper = Wrapper;
var ContentWrap = _styledComponents.default.div.withConfig({
  displayName: "style__ContentWrap",
  componentId: "c8dls-1"
})(["flex:1 1 100%;flex-direction:column;align-items:flex-start;order:2;@media (min-width:", "){flex:1;", " order:1;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.md;
}, (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      padding-right: ", ";\n    "])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.xl;
}));
exports.ContentWrap = ContentWrap;
var Content = _styledComponents.default.div.withConfig({
  displayName: "style__Content",
  componentId: "c8dls-2"
})(["align-items:flex-start;flex-direction:column;"]);
exports.Content = Content;
var Chart = _styledComponents.default.div.withConfig({
  displayName: "style__Chart",
  componentId: "c8dls-3"
})(["flex:auto;order:1;display:flex;position:relative;flex-direction:column;overflow:hidden;&::after{content:'';background:linear-gradient( to right,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 50% );width:75px;height:100%;position:absolute;right:-37.5px;top:0;display:block;pointer-events:none;@media (min-width:", "){content:none;}}@media (min-width:", "){flex:1;order:2;position:static;display:block;}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.sm;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.md;
});
exports.Chart = Chart;
var ChartWrap = _styledComponents.default.div.withConfig({
  displayName: "style__ChartWrap",
  componentId: "c8dls-4"
})(["overflow-x:auto;display:flex;width:100%;@media (min-width:", "){flex-direction:column;background:", ";}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.md;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.levelChart.chartBg;
});
exports.ChartWrap = ChartWrap;
var ChartItems = _styledComponents.default.div.withConfig({
  displayName: "style__ChartItems",
  componentId: "c8dls-5"
})(["flex:1;@media (max-width:", "){&:last-child{", "}}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.sm;
}, (0, _styledComponentsRtl.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        padding-right: ", ";\n      "])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.lg;
}));
exports.ChartItems = ChartItems;
var ChartHelper = _styledComponents.default.span.withConfig({
  displayName: "style__ChartHelper",
  componentId: "c8dls-6"
})(["display:flex;z-index:1;align-items:center;margin-bottom:", ";"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.lg;
});
exports.ChartHelper = ChartHelper;
var TitleBg = _styledComponents.default.span.withConfig({
  displayName: "style__TitleBg",
  componentId: "c8dls-7"
})(["display:inline-flex;padding:", " ", ";background-color:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.space.xxs;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.space.md;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.levelChart.titleBg;
});
exports.TitleBg = TitleBg;
var StyledH3 = (0, _styledComponents.default)(_typography.H3).withConfig({
  displayName: "style__StyledH3",
  componentId: "c8dls-8"
})(["color:", ";"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.levelChart.titleColor;
});
exports.StyledH3 = StyledH3;
var LevelGroup = _styledComponents.default.div.withConfig({
  displayName: "style__LevelGroup",
  componentId: "c8dls-9"
})(["width:100%;display:flex;align-items:center;"]);
exports.LevelGroup = LevelGroup;
var BarButton = _styledComponents.default.a.withConfig({
  displayName: "style__BarButton",
  componentId: "c8dls-10"
})(["width:100%;cursor:pointer;position:relative;text-decoration:none;transition:filter ", ";&:hover,&:focus{filter:brightness(1.05);}", ""], function (_ref20) {
  var animation = _ref20.theme.animation;
  return animation.transitionFast;
}, function (_ref21) {
  var lockedLevel = _ref21.lockedLevel;
  return lockedLevel && (0, _styledComponents.css)(["pointer-events:none;"]);
});
exports.BarButton = BarButton;
var BarGroup = _styledComponents.default.div.withConfig({
  displayName: "style__BarGroup",
  componentId: "c8dls-11"
})(["display:flex;width:100%;@media (min-width:", "){width:70%;flex-direction:column;", "}"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.breakpoints.md;
}, (0, _styledComponentsRtl.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      padding-right: ", ";\n    "])), function (_ref23) {
  var theme = _ref23.theme;
  return theme.space.sm;
}));
exports.BarGroup = BarGroup;
var Bar = _styledComponents.default.span.withConfig({
  displayName: "style__Bar",
  componentId: "c8dls-12"
})(["transition:", ";height:", ";min-width:", ";width:100%;display:block;background-color:", ";@media (min-width:", "){min-width:auto;width:", "%;}", ""], function (_ref24) {
  var theme = _ref24.theme;
  return theme.animation.transitionMedium;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.space.xxxl;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.space.xxxl;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.levelChart.barColors.default.bgColor;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.breakpoints.md;
}, function (_ref29) {
  var size = _ref29.size;
  return size * 100;
}, function (_ref30) {
  var theme = _ref30.theme,
    isActive = _ref30.isActive,
    level = _ref30.level;
  var barColors = theme.levelChart.barColors;
  if (isActive) {
    return (0, _styledComponents.css)(["background-color:", ";@media (max-width:", "){position:relative;}"], barColors.active.bgColor, function (_ref31) {
      var theme = _ref31.theme;
      return theme.breakpoints.md;
    });
  } // eslint-disable-next-line no-prototype-builtins

  if (barColors.hasOwnProperty(level)) {
    return (0, _styledComponents.css)(["background-color:", ";"], barColors[level].bgColor);
  }
});
exports.Bar = Bar;
var LevelGroupTitle = _styledComponents.default.span.withConfig({
  displayName: "style__LevelGroupTitle",
  componentId: "c8dls-13"
})(["display:none;@media (min-width:", "){display:flex;font-weight:", ";white-space:nowrap;z-index:1;", " font-size:", ";justify-content:flex-end;order:1;width:50%;}"], function (_ref32) {
  var theme = _ref32.theme;
  return theme.breakpoints.md;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.fontWeight.semiBold;
}, (0, _styledComponentsRtl.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      padding-right: ", ";\n    "])), function (_ref34) {
  var theme = _ref34.theme;
  return theme.space.lg;
}), function (_ref35) {
  var theme = _ref35.theme;
  return theme.fontSize.xxs;
});
exports.LevelGroupTitle = LevelGroupTitle;
var Level = _styledComponents.default.span.withConfig({
  displayName: "style__Level",
  componentId: "c8dls-14"
})(["display:flex;align-items:center;justify-content:center;color:white;height:100%;padding:0 ", ";user-select:none;@media (min-width:", "){justify-content:flex-start;}", ""], function (_ref36) {
  var theme = _ref36.theme;
  return theme.space.xs;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.breakpoints.md;
}, function (_ref38) {
  var theme = _ref38.theme,
    isActive = _ref38.isActive,
    level = _ref38.level;
  var barColors = theme.levelChart.barColors;
  if (isActive) {
    return (0, _styledComponents.css)(["color:", ";"], barColors.active.textColor);
  } // eslint-disable-next-line no-prototype-builtins

  if (barColors.hasOwnProperty(level)) {
    return (0, _styledComponents.css)(["color:", ";"], barColors[level].textColor);
  }
  return (0, _styledComponents.css)(["color:", ";"], barColors.default.textColor);
});
exports.Level = Level;